import { Box, Button, Dialog, DialogContent, makeStyles, Typography } from "@material-ui/core";
import React from "react";

import { CustomButton } from "@/components/Button";

import NotificationOfferImage from "@assets/image/notification_offer.png";
import NotificationSampleImage from "@assets/image/notification_sample.png";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: theme.spacing(2),
  },
  dialogContent: {
    padding: theme.spacing(4, 3, 3),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1, 2.5),
    },
  },
  header: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 700,
    textAlign: "center",
    lineHeight: 1.6,
  },
  description: {
    marginTop: theme.spacing(2),
    lineHeight: 1.8,
    textAlign: "center",
  },
  previewCard: {
    marginTop: theme.spacing(3),
    borderRadius: theme.spacing(1),
    overflow: "hidden",
  },
  previewImage: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  promptCopy: {
    textAlign: "center",
    marginTop: theme.spacing(3),
    lineHeight: 1.6,
    fontSize: "14px",
    color: theme.palette.text.secondary,
  },
  promptImage: {
    marginTop: theme.spacing(2),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[300]}`,
    overflow: "hidden",
  },
  primaryButton: {
    marginTop: theme.spacing(3),
    fontSize: "16px",
    height: 48,
    fontWeight: 700,
  },
  secondaryButton: {
    marginTop: theme.spacing(1),
    fontSize: "14px",
    height: 48,
    fontWeight: 700,
    "&.MuiButton-text": {
      color: theme.palette.text.disabled,
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  },
}));

type Props = {
  open: boolean;
  onAllow: () => void;
  onDismiss: () => void;
  loading?: boolean;
};

export const NotificationPermissionModal: React.FC<Props> = ({ open, onAllow, onDismiss, loading }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onDismiss} PaperProps={{ className: classes.dialogPaper }} maxWidth="xs" fullWidth>
      <DialogContent className={classes.dialogContent}>
        <Box className={classes.header}>
          <Typography variant="h3" className={classes.title}>
            “あなたに合った投資情報”を
            <br />
            逃さないために
          </Typography>
        </Box>

        <Typography className={classes.description}>
          あなたのニーズに合ったメッセージや厳選コラムを、最速でお届けします。
        </Typography>

        <Box className={classes.previewCard}>
          <img src={NotificationOfferImage} alt="通知サンプル" className={classes.previewImage} />
        </Box>

        <Typography className={classes.promptCopy}>設定画面で通知を許可してください。</Typography>

        <Box className={classes.promptImage}>
          <img src={NotificationSampleImage} alt="通知許可ダイアログの例" className={classes.previewImage} />
        </Box>

        <Box mt={3}>
          <CustomButton type="button" fullWidth customVariant="filled" onClick={onAllow} disabled={loading}>
            通知を受け取る（おすすめ）
          </CustomButton>
        </Box>

        <Button variant="text" fullWidth className={classes.secondaryButton} onClick={onDismiss} disabled={loading}>
          設定しない
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationPermissionModal;
